/*** 413861 - OwnPath UI - Fix the Veracode Issue
I've refactored src/components/Search/ResultCard.tsx to improve security and accessibility. 
The key change was replacing the vulnerable window.location.href with react-router-dom's useNavigate 
hook for navigation. I created a handleCardClick function, triggered by onClick and onKeyDown events 
on the main div, to encapsulate analytics and navigation logic. I also added role='link' and 
tabIndex={0} for better accessibility and removed the now-redundant Link component from the h2 title. 
This resolves the X.SS vulnerability and aligns with React best practices. I'm confident the task is 
complete.
***/
import { Grid } from "@trussworks/react-uswds";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { SurveyTriggerContext } from "../../App";
import { CompareContext } from "../../pages/Search/Search";

import { V1Clinic } from "../../types/v1_schemas";
//import { AnalyticsAction, logEvent } from "../../utils/analytics";
import BasicResultDetail from "../ResultDetail/BasicResultDetail";
//import { MilesAway } from "./MilesAway";
import { AnalyticsAction, logEvent } from "../../utils/analytics";


type ResultCardProps = {
  data: V1Clinic;
  isMobile?: boolean;
};

export default function ResultCard({ data, isMobile }: ResultCardProps) {
  const { selectedCompareProviders, setSelectedCompareProviders } = useContext(CompareContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [enterCard, setEnterCard] = useState(false);

  // Global application state to track trigger events for showing user
  // option to take site survey
  const { incrementTriggerEventCount } = useContext(SurveyTriggerContext);

  const toggleCompareCheckbox = () => {
    const thisProviderIdx = selectedCompareProviders.findIndex(
      (provider:any) => provider.accountId === data.accountId
    );

    const p = [...selectedCompareProviders];
    if (thisProviderIdx > -1) {
      p.splice(thisProviderIdx, 1);
    } else {
      p.push(data);
    }
    setSelectedCompareProviders(p);
  };

  const isSelectedForCompare = !!selectedCompareProviders.find(
    (v1Clinic:V1Clinic) => v1Clinic.accountId === data.accountId
  );

  const handleCardClick = () => {
    incrementTriggerEventCount();
    logEvent(AnalyticsAction.SelectProviderDetail, {
      count: 1,
    });

    const entryTime = parseInt((sessionStorage.getItem('searchCardEntryTime') ?? '0'), 10);
    const currentTime = Date.now();
    console.log('currentTime is ' + currentTime.toString());

    if (!isNaN(entryTime) && entryTime > 0) {
      const timeSpent = currentTime - entryTime; // in milliseconds
      console.log('timeSpent is ' + timeSpent.toString())

      logEvent(AnalyticsAction.ProviderSearchTime, {
        timeSpan: timeSpent
      })

      // Optional: clear after sending if you want to track only first transition
      sessionStorage.removeItem('searchCardEntryTime');
    }
    
    navigate(`/result/${data.accountId}`, { state: { prevSearch: location.search, data } });
  };

  return (
    <div 
      className={enterCard ? "padding-y-3 padding-x-5 result-card-hover" : "padding-y-3 padding-x-5 result-card-not-active"}
      role='link'
      tabIndex={0}
      onMouseEnter={() => {setEnterCard(true) }}
      onMouseLeave={() => {setEnterCard(false) }}
      onClick={handleCardClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleCardClick();
        }
      }}
      // Only set id in the desktop list to avoid creating
      // duplicate DOM elements with same id in mobile list
      id={isMobile ? undefined : data.accountId ?? "0"}
    >
      <Grid 
        row
        style={{gap: '17px'}}
        mobile={{ col: true }}
      >
        <div className="display-flex flex-justify" >
          <div className="search-rank" >
            <span >
              {data.searchRank}
            </span>
          </div>
          <h2 className="nice_font dark_blue margin-top-1 margin-bottom-1" style={{marginLeft: 13, color:'#1A103F'}} >{data.displayName}</h2>
        </div>
      </Grid>
      <div className="display-flex flex-justify" style={{ marginLeft: "60px", color:'#4F4F4F'}} >
          <BasicResultDetail result={data} isCondensed={true} />
      </div>
    </div>
  );
}
